import { HttpClient, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { IDepartment } from '@boma/administration-portal/shared/entities';
import { APP_CONFIG } from '@boma/app-config';

@Injectable({
  providedIn: 'root',
})
export class DepartmentsService {
  private base: string;
  private version: string;
  constructor(
    @Inject(APP_CONFIG) private configuration: any,
    private httpClient: HttpClient
  ) {
    this.base = configuration.apiRoute;
    this.version = configuration.apiVersion;
  }

  listDepartments() {
    return this.httpClient.get<IDepartment[]>(
      `${this.base}api/v${this.version}/Departments`
    );
  }

  searchDepartments(searchTerm: string) {
    return this.httpClient.get<IDepartment[]>(
      `${this.base}api/v${this.version}/Departments`,
      {
        params: { query: searchTerm },
      }
    );
  }

  uploadDepartmentImage(file: File) {
    let formData = new FormData();
    formData.append('file', file, file.name);
    return this.httpClient.post<string>(
      `${this.base}api/v${this.version}/Departments/UploadImage`,
      formData
    );
  }

  createDepartment(department: any) {
    return this.httpClient.post<IDepartment>(
      `${this.base}api/v${this.version}/Departments`,
      {
        ...department,
      }
    );
  }

  updateDepartment(department: any, departmentId: string) {
    return this.httpClient.put<IDepartment>(
      `${this.base}api/v${this.version}/Departments/${departmentId}`,
      {
        ...department,
      }
    );
  }

  deleteDepartment(departmentId: string) {
    return this.httpClient.delete<HttpResponse<any>>(
      `${this.base}api/v${this.version}/Departments/${departmentId}`
    );
  }
}
